<template>
  <div>
    <!--电商下单的商品，定制、现货和扩增-->
    <!--    <div class="block-item" style="padding: 10px 0;" v-if="order.fromEmkt">-->
    <!--      <img :src="emkt.getOrderMerchandiseLabel(item)" class="product-label" v-if="item.categoryId">-->
    <!--      <div class="block-address">-->
    <!--        <img v-if="item.merchandiseIcon"-->
    <!--             class="largeIcon"-->
    <!--             :src=baseurl+item.merchandiseIcon-->
    <!--        />-->
    <!--        <img v-else-if="item.categoryId === 20 || item.categoryId === 10"-->
    <!--             class="largeIcon"-->
    <!--             :src=baseurl+emkt.CUSTOMIZE_IMAGE-->
    <!--        />-->
    <!--        <img v-else class="largeIcon" :src=serviceUrl />-->
    <!--        <div class="item-detail" v-if="item.categoryId">-->
    <!--                <span class="deep-text-color" style="font-size: 12px;" v-if="item._titleList && item._titleList.length > 0">-->
    <!--                   <span v-for="title in item._titleList">-->
    <!--                     <span v-if="title.valueText && title.valueText !== '-1' && title.value !== '-1'"><span-->
    <!--                       v-if="title.columnName === 'TVInfo'">{{ title.valueText.TLNo }}</span><span v-else>{{ title.valueText }}</span>&nbsp;</span>-->
    <!--                  </span>-->
    <!--                </span>-->
    <!--          <span class="light-text-color small-font" v-if="item._subTitleList && item._subTitleList.length > 0">-->
    <!--                  <span v-for="(subTitle, index) in item._subTitleList">-->
    <!--                    <span v-if="index !== 0">/</span>-->
    <!--                    <span v-if="subTitle.valueText && subTitle.valueText !== '-1' && subTitle.value !== '-1' ">{{ subTitle.valueText }}</span>-->
    <!--                  </span>-->
    <!--                </span>-->
    <!--          <span class="light-text-color small-font" v-if="item._abstractList && item._abstractList.length>0">-->
    <!--                   <span v-for="(abstractTitle, index) in item._abstractList">-->
    <!--                     <span v-if="abstractTitle.valueText && abstractTitle.valueText !== '-1' && abstractTitle.value !== '-1' "><span-->
    <!--                       v-if="abstractTitle.columnName === 'TVInfo' && abstractTitle.valueText.TLNo !== undefined">{{ abstractTitle.valueText.TLNo }}</span><span-->
    <!--                       v-else>{{ abstractTitle.valueText }}</span>&nbsp;</span>-->
    <!--                   </span>-->
    <!--                </span>-->
    <!--        </div>-->
    <!--        <div class="item-detail" v-else>-->
    <!--                <span class="deep-text-color" style="font-size: 12px;">-->
    <!--                   {{ item.name }}-->
    <!--                </span>-->
    <!--          <span class="light-text-color small-font">-->
    <!--                  <span>-->
    <!--                    {{ stringSet(item.serviceItemDetail && item.serviceItemDetail.productInfoList[0]) }}-->
    <!--                  </span>-->
    <!--                </span>-->
    <!--          <span class="light-text-color small-font">-->
    <!--                   <span>-->
    <!--                     {{ item.serviceItemDetail && item.serviceItemDetail.productInfoList[1] }}-->
    <!--                   </span>-->
    <!--                </span>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--      <span class="light-text-color">X {{ item.quantity }}</span>-->
    <!--    </div>-->
    <!--电商、SF下单的商品，定制和扩增-->
    <div class="block-item" style="padding: 10px 0;" v-if="item.orderType === 1">
      <img v-if="item.iconTag" :src="calTagName(item)" class="product-label">
      <img v-else :src="emkt.getOrderMerchandiseLabel(item)" class="product-label">
      <div class="block-address">
        <img v-if="item.iconUrl"
             class="largeIcon"
             :src='item.iconUrl'
        />
        <img v-else-if="item.merchandiseIcon"
             class="largeIcon"
             :src=baseurl+item.merchandiseIcon
        />
        <img v-else-if="item.isStock === 0"
             class="largeIcon"
             :src=baseurl+emkt.CUSTOMIZE_IMAGE
        />
        <div class="item-detail">
          <span class="deep-text-color" style="font-size: 12px;">{{ item.name }} </span>
          <span class="research-font-color small-font" v-if="showProductContractNo">{{item.contractNo}}</span>
          <span class="light-text-color small-font">{{ item.TLNo }} {{ item.tag1PUBID }} {{ item.eu_RID }}</span>
          <span class="light-text-color small-font" v-if="item.tax">{{ item.tax }} <span v-if="item.symbol">{{ item.symbol }}</span></span>
        </div>
      </div>
      <span class="light-text-color">X {{ item.quantity }}</span>
    </div>
    <!--服务类商品-->

    <div class="block-item" style="padding: 10px 0;" v-else>
      <!--         v-else-if="(item.productType==='服务类'||item.productType==='非消费合同-常规预收')&&(item.contractNoSrc===''||item.contractNoSrc===undefined)">-->
      <div class="block-address">
        <img
          class="largeIcon"
          :src="baseurl + 'service_product.png'"
        />
        <div class="item-detail">
          <span class="deep-text-color" style="font-size: 12px;">{{ item.name }}</span>
          <span class="research-font-color small-font" v-if="showProductContractNo">{{item.contractNo}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import EMKT from '../constant'
import EMKT from '../../../constant'

export default {
  components: {},
  props: {
    item: Object,
    order: Object,
    showProductContractNo: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      baseurl: EMKT.MERCHANDISE_IMG_BASE_URL,
      serviceUrl: EMKT.MERCHANDISE_IMG_BASE_URL + 'service.png',
      emkt: EMKT
    }
  },
  mounted () {
  },
  computed: {},
  methods: {
    stringSet (str) {
      if (str) {
        let s = str.replace(/&nbsp;/ig, ' ')
        return s
      } else {
        return ''
      }
    },
    calTagName (item) {
      let iconTag
      const type = item.iconTag
      console.log('type:', type)
      if (type === EMKT.PRODUCT_TYPE_ID.customMade) {
        iconTag = EMKT.PRODUCT_CATEGORY_ICON_TAG_CUSTOMIZE
      } else if (type === EMKT.PRODUCT_TYPE_ID.amplification) {
        iconTag = EMKT.PRODUCT_CATEGORY_ICON_TAG_AMPLIFICATION
      } else {
        iconTag = EMKT.PRODUCT_CATEGORY_ICON_TAG_STOCK
      }
      return `${EMKT.MERCHANDISE_IMG_BASE_URL_RTMES}/imgs/toolVector/${EMKT.ICON_TAG_IMAGE_MAP[iconTag]}`
    },
    getSmartFileSrc (iconGuid) {
      return `${EMKT.MERCHANDISE_IMG_BASE_URL_SMART}/smart-files/preview/${iconGuid}`
    }
  }
}
</script>

<style scoped>
.product-label {
  z-index: 5;
  width: 30px;
  position: absolute;
  top: 0;
  left: -15px;
}

.block-address {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  width: 90%;
}

.item-detail {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-left: 10px;
  width: 75%;
}

row {
  position: relative;
  margin-top: 2.4vw;
  border-top-width: 0.7px;
  border-top-style: solid;
  border-top-color: rgba(239, 238, 243, 1);
  width: 94.67vw;
  height: 0.27vw;
}

.deep-text-color {
  color: #424242;
  font-size: 12px;
  /*font-weight: 500;*/
  font-weight: bold;
}

.small-font {
  font-size: 12px;
  transform: scale(0.8);
  transform-origin: left center;
}

.block-item {
  /*height: 35px;*/
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background-color: #fff;
}


.light-text-color {
  color: #929292;
  font-size: 12px;
}


.largeIcon {
  position: relative;
  width: 60px;
  height: 60px;
}


</style>



// WEBPACK FOOTER //
// GcOrderProductBase.vue?608ffc12